import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const ScrollContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

export const Container = styled.div`
  height: 100%;
  width: 100%;

  .fc {
    ${({ theme }) => typographyToCss(theme.typography.overline)};

    color: ${({ theme }) => theme.palette.text.secondary};
  }

  .fc table {
    border-width: 0;
  }

  .fc-scrollgrid-section.fc-scrollgrid-section-body:first-child {
    background: ${({ theme }) => theme.palette.background.default};
  }

  .fc .fc-scrollgrid-section-sticky > * {
    background: transparent;
  }

  /* Header cells */
  .fc .fc-day-sat,
  .fc .fc-day-sun {
    background-color: ${({ theme }) => rgba(theme.palette.grey[50], 0.5)};
  }

  /* TimeGrid columns (where events are) */
  .fc .fc-timegrid-col.fc-day-sat,
  .fc .fc-timegrid-col.fc-day-sun {
    background-color: ${({ theme }) => rgba(theme.palette.grey[50], 0.5)};
  }

  .fc .fc-daygrid-body .fc-timegrid-axis {
    background: ${({ theme }) => theme.palette.background.default};
  }

  tr > th.fc-timegrid-axis {
    border-right-color: transparent;
  }

  .fc-timegrid-slot-label {
    width: 6rem;
    background: ${({ theme }) => theme.palette.background.default};
  }

  .fc .fc-col-header-cell-cushion {
    padding: ${({ theme }) => theme.spacing(2)};
  }

  .fc-header-toolbar {
    display: none;
  }

  .fc-timegrid-divider {
    display: none;
  }

  .fc-timegrid-col,
  .fc-timegrid-slot {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-more-popover {
    visibility: hidden;
    height: 0;
    width: 0;
    overflow: hidden;
  }

  /* Set the "+N more" link size explicitly (rem, not the inherited em-scaled
     base) so it's the true overline size and identical across week/month. */
  .fc .fc-daygrid-more-link {
    ${({ theme }) => typographyToCss(theme.typography.overline)};
    color: ${({ theme }) => theme.palette.text.primary};
  }

  .fc-timegrid-now-indicator-arrow {
    display: none;
  }

  .fc-daygrid-day.fc-day-today,
  .fc-timegrid-col.fc-day-today {
    background: inherit;
  }

  .fc-timegrid-event .fc-event-main {
    padding: 0;
  }

  .fc .fc-col-header-cell {
    border-right-color: transparent;
    border-left-color: transparent;
    background: ${({ theme }) => theme.palette.background.default};
  }

  .fc-day {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-scrollgrid-section td,
  .fc-scrollgrid-section th {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-view .fc-scrollgrid .fc-scrollgrid-section:last-child td {
    border-bottom-color: transparent;
  }

  .fc-scrollgrid-section .fc-timegrid-slot-minor {
    border-top-color: transparent;
  }

  .fc .fc-highlight {
    background: ${({ theme }) =>
      theme.palette.primaryExtended.opacityBackgroundBackground};
  }

  .fc-event {
    padding: 0;

    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }

  /* Drop FullCalendar's default 1px top margin on all-day events. */
  .fc .fc-daygrid-event {
    margin-top: 0;
  }
`;
